import React, { useState } from 'react'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import ResponsiveModalDrawerDialog from 'src/Elements/Utilities/ResponsiveModalDrawerDialog'
import { ActionProps } from 'src/Elements/Utilities/ResponsiveModalDrawerActions'
import CookieForm from './CookieForm'
import { useCookies } from 'src/Libs/cookies'
import { Button, Theme, useMediaQuery } from '@mui/material'

export interface CookieModalProps {
  isOnProfilePage?: boolean
  init?: () => Promise<void>
  onClose?: () => void
  place?: number
}

/**
 *  Modal to manage cookies
 */
const CookieModal: React.FC<CookieModalProps> = props => {
  const { onClose, isOnProfilePage = false, init } = props
  const { t } = useCustomTranslation()
  const { cookies, setConsentAgreed, setGoogleAgreed } = useCookies()
  const [essentialsCookie] = useState(true)
  const [googleMapsCookie, setGoogleMapsCookie] = useState(cookies.googleAgreed ?? false)
  const downMd = useMediaQuery((theme: Theme) => theme.breakpoints.down('md'))

  const handleAcceptCookieSettings = (acceptAll: boolean, rejectOptional?: boolean): void => {
    if (acceptAll) {
      setGoogleAgreed(true)
    } else if (rejectOptional) {
      setGoogleAgreed(false)
    } else {
      setGoogleAgreed(googleMapsCookie)
    }
    setConsentAgreed(true)
    onClose?.()
    if (isOnProfilePage || !init) return
    init()
  }

  const leftControls: React.ReactNode = (
    <Button
      variant={'outlined'}
      color={'inherit'}
      onClick={() => handleAcceptCookieSettings(false, true)}
      fullWidth={downMd}
      data-qa={'cookie-modal-reject-optional'}
    >
      {t('cookies.reject-optional')}
    </Button>
  )

  const secondaryAction: ActionProps = {
    label: t('cookies.accept-selection'),
    onClick: () => handleAcceptCookieSettings(false),
    dataQa: 'cookie-modal-accept-selection',
  }

  const primaryAction: ActionProps = {
    label: t('cookies.accept-all'),
    onClick: () => handleAcceptCookieSettings(true),
    dataQa: 'cookie-modal-accept-all',
  }

  return (
    <ResponsiveModalDrawerDialog
      hasCloseButton={isOnProfilePage}
      closableOnlyWithActionButtons={!isOnProfilePage}
      onClose={onClose}
      title={t('cookies.title')}
      secondaryAction={secondaryAction}
      primaryAction={primaryAction}
      modalMaxWidth={'sm'}
      leftControls={leftControls}
    >
      <CookieForm essentialsCookie={essentialsCookie} googleMapsCookie={googleMapsCookie} setGoogleMapsCookie={setGoogleMapsCookie} />
    </ResponsiveModalDrawerDialog>
  )
}

export default CookieModal
